export const ACTIONS = {
  UPDATE_STUDENT_CONSECUTIVE_CORRECT_ANSWER: 'STUDENT_CONSECUTIVE_CORRECT_ANSWER_UPDATED',
  CLEAR_STUDENT_CONSECUTIVE_CORRECT_ANSWER: 'CLEAR_STUDENT_CONSECUTIVE_CORRECT_ANSWER',
} as const;

export interface UpdateStudentConsecutiveCorrectAnswer<
  P = {
    consecutiveCount: number;
  },
> {
  (payload: P): {
    type: typeof ACTIONS.UPDATE_STUDENT_CONSECUTIVE_CORRECT_ANSWER;
    payload: P;
  };
}

export const UpdateStudentConsecutiveCorrectAnswer: UpdateStudentConsecutiveCorrectAnswer =
  payload => ({
    type: ACTIONS.UPDATE_STUDENT_CONSECUTIVE_CORRECT_ANSWER,
    payload,
  });

export const ClearStudentConsecutiveCorrectAnswer = () => ({
  type: ACTIONS.CLEAR_STUDENT_CONSECUTIVE_CORRECT_ANSWER,
});
